<template>
  <div  class="toolbar" :class="{'editing': mode === 'editing'}" >
    <!--<scrub-bar class="toolbar__scrubbar" :position="relativePosition" @input="setPosition" />-->
    <cling-slider :min="0" :max="videoDuration" :value="currentTime" @input="setPosition"></cling-slider>
    <!--
    <div v-if="mode != 'editing'">
      <button class="button" @click="toggle_play" v-bind:disabled="!player || selection.waypoint">
        <i v-if="player && player.paused()" class="material-icons">play_arrow</i>
        <i v-else class="material-icons">pause</i>
      </button>
    </div>
    -->

     <div v-if="mode === 'editing' && selection.tag" class="toolbar__edit-track-wrapper">
      <tag-track style="margin-left:-121px;" :tag="selection.tag" @saveScene="onSaveScene" />
    </div>

    <controls :mode="mode" v-on:mute="onMute" @saveScene="onSaveScene" />
   
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
// import scrubBar from './scrubBar'
import controls from './controls'
import TagTrack from '../editor/tagTrack'
import clingSlider from '../core/clingSlider'
import { validateScene } from '../../validation/index.js';
import { saveScene } from '../../mixins/saveScene.js'

export default {
  name: 'toolbar',

  components: {
    // 'scrub-bar': scrubBar,
    controls,
    'tag-track': TagTrack,
    'cling-slider': clingSlider
  },

  mixins: [saveScene],

  computed: {
    ...mapState(['player', 'mode', 'selection']),
    ...mapGetters(['currentTime', 'videoDuration', 'video']),

    relativePosition() {
      return this.videoDuration ? this.currentTime / this.videoDuration : 0
    }
  },

  methods: {
    ...mapMutations(['selectScene', 'setMode', 'resetSelection']),
    formatTimestamp(duration) {
      return `${Math.floor(duration / 60)}:${Math.floor(duration % 60)}.${Math.floor(duration % 1 * 1000)}`
    },

    toggle_play() {
      if (this.player) {
        if (this.player.paused()) {
          this.player.play()
        } else {
          this.player.pause()
        }
      }
    },

    setPosition(pos) {
      if (this.player) {
        this.player.currentTime(pos)
      }
    },
    
    onSaveScene() {
      // see mixin
      this.saveScene()
    },

    onMute() {
      this.$parent.$emit('mute')
    }
    
  }
}
</script>
